import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Pagination from '../../common/Pagination'
import { HttpRequestService } from '../../services/HttpRequestService';
import { UtilsService } from '../../services/UtilsService';

class BatchList extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            batches: [],
            pageCount: 0,
            pageIndex: 0
        }
        this.paramsKey = "params.batch-list";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();        
        this.handlePageChange = this.handlePageChange.bind(this);
        this.pageSize = 50;
        this.getBatches = this.getBatches.bind(this);
    }

    componentDidMount() {
        this.getBatches(this.state.pageIndex);
    }    

    handlePageChange(page) {
        this.getBatches(page);
    }

    getBatches(page) {
        this.setState({ pageIndex: page });
        var params = {
            pageSize: this.pageSize,
            pageIndex: page
        }

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Inventory/GetBatchList', params).then(data => {
            this.setState({ batches: data.data, pageCount: parseInt(Math.ceil(data.count / this.pageSize)) });
        });
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Batch List</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="form-row">
                                    <table className="table table-striped mt-1">
                                        <thead>
                                            <tr>
                                                <th scope="col">Batch ID</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.batches.map((batch) =>
                                                <tr key={batch.batchId}>
                                                    <td><Link to={"/inventory/batch/" + batch.batchId}>{batch.batchId}</Link></td>
                                                    <td>{batch.description}</td>
                                                    <td>{batch.date}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        {this.state.batches.length > 0 &&
                                            <Pagination pageIndex={this.state.pageIndex} pageCount={this.state.pageCount} onPageChanged={this.handlePageChange}></Pagination>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BatchList;
